import { isCustomizeDressField } from '../isCustomizeDressAttribute';

export function getSelectCustomRule(product, allFormData): any {
  const result: Array<string> = [];

  for (const data in allFormData) {
    if (isCustomizeDressField(data)) {
      const selectedValue = allFormData[data];

      const attribute = product.ampProtOption.items.find(temp => temp.attribute_id === selectedValue.option_id);

      const originalSelectedValue = attribute.values.find(
        temp => temp.value_index.toString() === selectedValue.value_index.toString(),
      );

      result.push(`${originalSelectedValue.default_label}@@${originalSelectedValue.sku}`);
    }
  }
  return result;
}
